import React from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';

import { useAuth } from '../../../../../../hooks/Auth';
import { FiSend } from 'react-icons/fi';
import { FaBarcode, FaCopy, FaFileExcel, FaQrcode, FaReceipt } from 'react-icons/fa';
import { useConfiguration } from '../../../../../../hooks/Configuration';
import { date } from '../../../../../../utils/date';
import { formatReal } from '../../../../../../utils/format';
import { downloaditPost } from '../../../../../../utils/download';
import { apiUrl } from '../../../../../../config';
import { useLoading } from '../../../../../../hooks/LoadingHook';
import { FormHandles } from '@unform/core';
import { sanitizeData } from 'src/pages/DashboardPages/core/components/FormComponent';
import FormComponent from 'src/pages/DashboardPages/core/components/FormComponent';
import { uuid } from 'uuidv4';
import { useModal } from 'src/hooks/Modal';

interface ICreateModule {
  lineData: Record<string, any>;
}

export default function UpdateModule({lineData}): JSX.Element {
  const { handleApiErrors } = useAuth();
  const { addToast } = useToast();
  const {addModal, removeModal} = useModal();
  const { addLoading, removeLoading } = useLoading();
  const { configuration } = useConfiguration();


  const prepareDuplicate = async (data) => {


    const item = await api.get(`/sales-invoice/${lineData?._id?.toString()}`);

    const content = {...data};

    content.project_id = item?.data?.project_id;
    content.event_id = item?.data?.event_id;

    content.sale_hash = item?.data?.sale_hash;
    content.invoice_hash = uuid();
    content.client_id = item?.data?.client_id_response?._id?.toString();
    content.client_id_response = item?.data?.client_id_response;

     content.payer_id = item?.data?.payer_id_response?._id?.toString();
    content.payer_id_response = item?.data?.payer_id_response || {};
    content.payment_status_id = 'waiting';

    content.juros = sanitizeData.currencyInput(data?.juros);
    content.total = sanitizeData.currencyInput(data?.total);
    content.multa = sanitizeData.currencyInput(data?.multa);
    content.discount = sanitizeData.currencyInput(data?.discount);
    content.installment_value = sanitizeData.currencyInput(data?.installment_value);

    try{
   await api.post(`/sales-invoice`, content);

    addToast({title: 'Inserido com sucesso', type: 'success'});
      removeModal('modal')
    }
    catch(err){
      addToast({title: 'Erro ao inserir', type: 'error'});
    }


  }
 

  const createModal = async () => {


     const products =  await api.get(`/products`, {params: { where: { project_id : lineData?.project_id}}});

     const options : any = [];

     products?.data?.rows?.map( item => {

      options.push({label: item?.title, value: item?._id?.toString()})


     })

const callback = (string, form: React.RefObject<FormHandles>) => {
  const installments = form?.current?.getFieldValue('installment') || 1;

  const discount =
    sanitizeData.currencyInput(form?.current?.getFieldValue('discount')) || 0;

  const total =
    sanitizeData.currencyInput(form?.current?.getFieldValue('total')) || 0;

  const installmentValue = parseInt(
    ((total - discount) / installments).toString(),
    10,
  );

  form?.current?.setFieldValue('installment_value', installmentValue);
};

 const formSchema : Record<string,any> = {

    product_id: {
      alias: 'product_id',
      model: 'selectSimple',
      name: 'product_id',
      label: 'Produto',

      options
    },
 payment_date: { model: 'datePicker', type: 'text', name: 'payment_date', label: 'Data de vencimento' },
 
   

    payment_method_id: {
      model: 'selectSimple',
      name: 'payment_method_id',
      label: 'Método de pagamento',

      options: [

        { label: 'Boleto', value: 'boleto_recurring' },
        { label: 'Cartão', value: 'credit_card_recurring' },


      ]

    },
    
    total: {
      model: 'currencyInput',
      name: 'total',
      label: 'Total',
      defaultValue: '0',
      callback,
    },
    juros: {
      model: 'currencyInput',
      name: 'juros',
      label: 'Juros',
      defaultValue: '0',
      callback,
    },
    multa: {
      model: 'currencyInput',
      name: 'multa',
      label: 'Multa',
      defaultValue: '0',
      callback,
    },
    discount: {
      model: 'currencyInput',
      name: 'discount',
      label: 'Desconto',
      defaultValue: '0',
      callback,
    },

    installment: {
      model: 'selectSimple',
      name: 'installment',
      label: 'Nº de Parcelas',
      defaultValue: '1',
      options: [
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
        { label: '6', value: 6 },
        { label: '7', value: 7 },
        { label: '8', value: 8 },
        { label: '9', value: 9 },
        { label: '10', value: 10 },
        { label: '11', value: 11 },
        { label: '12', value: 12 },
      ],
      callback,
    },
    installment_value: {
      model: 'currencyInput',
      name: 'installment_value',
      label: 'Valor da parcela',
      defaultValue: '0',
      readOnly: true,
    },

   
  };


    const content = <FormComponent schema={formSchema} setCallback={prepareDuplicate}/>;

    addModal({title: '', theme:'whiteModalMini', key: 'modal', content: <><p>Nova cobrança</p>
    <p>{lineData?.client_id_response?.name}</p>

    {content}
    
    </>})




  }


  const moduleUpdate = (): JSX.Element => (
    <button className="lineIcon" title="Gerar nova cobrança" onClick={() => { createModal() }} type="button"  >
      <FaBarcode color='blue' />
    </button>
  );

  return moduleUpdate();
}
